import { Injectable } from "@angular/core";
import { NetworkService } from "../../common/network.service";

@Injectable()
export class EventService {
  constructor(private _networkService: NetworkService) { }

  getEventList(query:any) {
    return this._networkService.get("api/events?"+query, null, null, "bearer");
  }
  getCourseList() {
    return this._networkService.get("api/course/v1", null, null, "bearer");
  }
  getEventById(query) {
    return this._networkService.get("api/events?" + query, null, null, "bearer");
  }
  getSavedEventById(query) {
    return this._networkService.get("api/saveEvents/"+ query, null, null, "bearer");
  }
  
  saveEvent(body: any) {
    return this._networkService.post("api/events", body, null, "bearer");
  }
  EditEvent(body: any) {
    return this._networkService.put("api/events", body, null, "bearer");
  }

  deleteEvent(id: any) {
    return this._networkService.delete("api/events/" + id, null, "bearer")
  }
  uploadImage(image: File) {
    const formData = new FormData();
    formData.append("image",image);
    return this._networkService.uploadImages("api/s3upload/", formData, null, "bearer");
  }
  uploadImageBlob(blob: any) {
    const formData = new FormData();
    formData.append("image", blob);
    return this._networkService.uploadImages("api/s3upload/image-upload", formData, null, "bearer");
  }
  
}
